<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif; background: #f4f6f9; min-height: 100vh;">
    <div class="max-w-7xl mx-auto px-4 py-6">

      <!-- VOLTAR -->
      <button @click="$router.back()" class="flex items-center gap-2 text-slate-500 hover:text-orange-500 transition-colors mb-6 group">
        <v-icon small color="inherit" class="group-hover:-translate-x-1 transition-transform">mdi-arrow-left</v-icon>
        <span class="text-[10px] font-bold uppercase tracking-widest">Voltar para Secretarias</span>
      </button>

      <div class="space-y-6 pb-24">
        
        <!-- FORMULÁRIO DE CADASTRO/EDIÇÃO -->
        <section class="bg-white rounded-xl overflow-hidden shadow-sm border border-slate-100">
          <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
            <v-icon color="orange" small>{{ subSecData.subsec_id ? 'mdi-pencil' : 'mdi-plus-circle' }}</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
              {{ subSecData.subsec_id ? 'ATUALIZAR FICHA' : 'NOVO CENTRO DE CUSTO' }}
            </h2>
          </div>
          
          <div class="p-6">
            <form @submit.prevent="createOrUpdate" class="flex flex-col md:flex-row items-end gap-4">
              <div class="flex-1 w-full">
                <label class="field-label">DESCRIÇÃO DA FICHA CONTÁBIL</label>
                <v-text-field 
                  v-model="subSecData.subsec_desc"
                  ref="secName"
                  placeholder="EX: FINANCEIRO / RECEPÇÃO / ALMOXARIFADO"
                  outlined dense hide-details
                  class="field-input font-bold uppercase"
                />
              </div>
              
              <div class="flex gap-2 w-full md:w-auto">
                <button 
                  v-if="subSecData.subsec_id"
                  type="button"
                  @click="newData"
                  style="background: none; border: none; cursor: pointer; height: 42px;"
                  class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest px-4 transition-colors"
                >
                  CANCELAR
                </button>
                <button 
                  type="submit"
                  :disabled="loader"
                  style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; min-width: 160px;"
                >
                  <v-icon v-if="!loader" small color="white">mdi-check</v-icon>
                  <v-icon v-else small class="animate-spin" color="white">mdi-loading</v-icon>
                  <span>{{ subSecData.subsec_id ? 'SALVAR' : 'CADASTRAR' }}</span>
                </button>
              </div>
            </form>
          </div>
        </section>

        <!-- LISTAGEM -->
        <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
            <div style="background-color: #333333; display: flex; align-items: center; padding: 10px 20px; width: 100%; box-sizing: border-box;">
                <div style="display: flex; align-items: center; gap: 8px; flex-shrink: 0;">
                  <v-icon color="orange" small>mdi-format-list-bulleted</v-icon>
                  <span style="color: white; font-weight: 700; font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em;">SUB-SETORES VINCULADOS</span>
                </div>
                
                <div style="margin-left: auto; display: flex; align-items: center; gap: 12px; flex-shrink: 0; width: 300px;">
                  <v-text-field
                    v-model="search"
                    placeholder="PESQUISAR..."
                    outlined dense hide-details
                    class="field-input-dark w-full"
                    prepend-inner-icon="mdi-magnify"
                  />
                </div>
            </div>

            <div class="overflow-x-auto">
                <v-data-table
                  :headers="headers"
                  :items="data"
                  :search="search"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  :loading="loader"
                  loading-text="PROCESSANDO DADOS..."
                  class="custom-table"
                  hide-default-footer
                >
                  <template v-slot:item.subsec_desc="{ item }">
                    <span class="text-sm font-bold text-slate-700 uppercase">{{ item.subsec_desc }}</span>
                  </template>

                  <template v-slot:item.sec_name="{ item }">
                    <span class="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{{ item.sec_name }}</span>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <div class="flex justify-end gap-2 px-4">
                      <button @click="loadData(item)" class="p-2 hover:bg-orange-50 text-orange-600 rounded-lg transition-colors" title="Editar">
                        <v-icon small color="orange">mdi-pencil</v-icon>
                      </button>
                      <button @click="deleteItem(item.subsec_id)" class="p-2 hover:bg-red-50 text-red-600 rounded-lg transition-colors" title="Excluir">
                        <v-icon small color="red">mdi-delete</v-icon>
                      </button>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <div class="py-12 flex flex-col items-center justify-center text-slate-400">
                      <v-icon size="48" color="slate-100">mdi-database-off</v-icon>
                      <p class="mt-2 text-[10px] font-bold uppercase tracking-widest">Nenhuma ficha encontrada</p>
                    </div>
                  </template>
                </v-data-table>

                <!-- Custom Pagination Footer -->
                <div class="bg-slate-50 px-6 py-6 border-t border-slate-100 flex flex-col items-center justify-center gap-4 text-[10px] text-slate-400 font-bold uppercase tracking-widest">
                    <span>Exibindo {{ (page - 1) * itemsPerPage + 1 }} de {{ data.length }} registros</span>
                    
                    <div class="flex gap-2">
                        <button 
                          @click="page > 1 ? page-- : null" 
                          :disabled="page === 1"
                          class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 transition-all"
                        >
                          Anterior
                        </button>
                        
                        <button 
                          v-for="p in visiblePages" 
                          :key="p"
                          @click="page = p"
                          :class="p === page ? 'bg-slate-700 text-white shadow-sm' : 'bg-white border-slate-200 hover:bg-slate-100'"
                          class="w-8 h-8 border rounded-lg transition-all flex items-center justify-center"
                        >
                          {{ p }}
                        </button>

                        <button 
                          @click="page < pageCount ? page++ : null" 
                          :disabled="page === pageCount"
                          class="px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 disabled:opacity-50 transition-all"
                        >
                          Próximo
                        </button>
                    </div>
                </div>
            </div>
        </section>
      </div>
    </div>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar v-model="snack.show" :color="snack.color" timeout="4000" top elevation="24" class="custom-snack">
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-bold uppercase tracking-widest">{{ snack.message }}</span>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      search: "",
      loader: true,
      data: [],
      subSecData: {
        subsec_desc: "",
        subsec_id: null,
        sec_id: this.id
      },
      snack: {
        show: false,
        message: "",
        color: ""
      },
      headers: [
        { text: "Descrição da Ficha", value: "subsec_desc" },
        { text: "Secretaria Vinculada", value: "sec_name" },
        { text: "Ações", align: "right", value: "action", sortable: false }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    visiblePages() {
      const pages = [];
      const totalVisible = 5;
      let start = Math.max(1, this.page - Math.floor(totalVisible / 2));
      let end = Math.min(this.pageCount, start + totalVisible - 1);
      if (end - start + 1 < totalVisible) start = Math.max(1, end - totalVisible + 1);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.data = [];
      this.$store.dispatch("setLoader", this.loader);
      this.$http.get(`/prefectures/subsectors/${this.id}`).then(r => {
        this.data = r.data;
        this.loader = false;
        this.$store.dispatch("setLoader", false);
      }).catch(e => {
        this.loader = false;
        this.snack.show = true;
        this.snack.message = e;
        this.snack.color = "error";
        this.$store.dispatch("setLoader", false);
      });
    },
    newData() {
      this.subSecData.subsec_desc = "";
      this.subSecData.subsec_id = null;
      if (this.$refs.secName) this.$refs.secName.focus();
    },
    loadData(data) {
      this.subSecData.subsec_desc = data.subsec_desc;
      this.subSecData.subsec_id = data.subsec_id;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    createOrUpdate() {
      if (!this.subSecData.subsec_desc) {
          this.snack.show = true; this.snack.message = "Informe o nome da ficha contábil"; this.snack.color = "warning"; return;
      }
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      const method = this.subSecData.subsec_id ? 'put' : 'post';
      const url = this.subSecData.subsec_id 
        ? `/prefectures/subsectors/${this.subSecData.subsec_id}` 
        : `/prefectures/subsectors/${this.id}`;
      this.$http[method](url, this.subSecData).then(r => {
        this.snack.show = true; this.snack.message = r.data.result; this.snack.color = "success";
        this.initialize(); this.newData();
      }).catch(e => {
        this.snack.show = true; this.snack.message = e.message; this.snack.color = "error";
        this.loader = false; this.$store.dispatch("setLoader", false);
      });
    },
    deleteItem(id) {
      if (confirm("Deseja excluir o registro?")) {
        this.$store.dispatch("setLoader", true);
        this.$http.delete(`/prefectures/subsectors/${id}`).then(r => {
          this.snack.show = true; this.snack.message = r.data.result; this.snack.color = "success";
          this.initialize();
        }).catch(e => {
          this.snack.show = true; this.snack.message = e.message; this.snack.color = "error";
          this.$store.dispatch("setLoader", false);
        });
      }
    }
  }
};
</script>

<style scoped>
.field-label {
  display: block;
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
}

.field-input >>> .v-input__control .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 6px !important;
}

.field-input >>> .v-input__control .v-input__slot fieldset {
  border-color: #e2e8f0 !important;
  border-width: 1px !important;
}

.field-input >>> .v-input__control .v-input__slot:hover fieldset {
  border-color: #f37021 !important;
}

.field-input >>> input {
  font-size: 13px !important;
  color: #334155 !important;
}

.field-input-dark >>> .v-input__control .v-input__slot {
  background-color: #333333 !important;
  border-radius: 6px !important;
}

.field-input-dark >>> .v-input__control .v-input__slot fieldset {
  border-color: #444444 !important;
}

.field-input-dark >>> input {
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 11px !important;
  text-transform: uppercase !important;
}

.custom-table ::v-deep table { background-color: transparent !important; border-collapse: separate; border-spacing: 0; }
.custom-table ::v-deep th { 
  color: #94a3b8 !important; 
  font-weight: 700 !important; 
  text-transform: uppercase !important; 
  font-size: 10px !important; 
  letter-spacing: 0.05em !important;
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  height: 48px !important;
}
.custom-table ::v-deep td { 
  border-bottom: 1px solid #f1f5f9 !important;
  color: #334155 !important;
  font-size: 13px !important;
}

.custom-snack >>> .v-snack__wrapper {
  border-radius: 10px !important;
}

@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
.animate-spin { animation: spin 1s linear infinite; }
</style>